export * from './lib/modal.module';
export * from './lib/modal/ebw-modal/ebw-modal.component';
export * from './lib/modal/hidden-modal-button/hidden-modal-button.component';
export * from './lib/modal/service/ebw-modal.service';
export * from './lib/modal/model/ebw-modal.model';
